import React, { useMemo, useRef, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { CloseIcon, SimpleCloseIcon } from '../../../../../assets/Logos/Icons'
import styles from './index.module.scss'
import * as yup from 'yup';
import { useEffect } from 'react';

function AddDataModal({ showModal, hidemodal, title, onSubmit }) {


    const [error, setError] = useState()
    let [name, setName] = useState()
    const inputRef = useRef()

    let schema = yup.object().shape({
        name: yup.string().required(),
    });


    const handleSubmit = async () => {

         let value = inputRef?.current?.value
        if(value)
        {
            hidemodal()
            onSubmit && onSubmit({name:value, isNew:true})
            setError(null);

        }
        else{
            setError("Name is a required field !!!");
        }

        // let value = inputRef?.current?.value
        // schema.validate({ name: value }).then((res) => {
        //     hidemodal()
        //     onSubmit && onSubmit({name:value, isNew:true})
        // }).catch((err => {
        //     setError("Name is a required field !!!");
        // }))

    }


    useEffect(() => {
        setName(false)
    }, [showModal])


    return (
        <Modal
            key={showModal}
            closeButton
            show={showModal}
            onHide={hidemodal}
            className={styles.patient_consent_modal_align}
            backdrop="static"

        >
            <Modal.Body>
                <div className={styles.modalContent}>

                    <div className={styles.closeBar} onClick={hidemodal}>
                        <SimpleCloseIcon />
                    </div>
                    <div className={styles.title}>{title}</div>


                    <div className={styles.form_item}>
                        <div className={styles.form_item_caption}>Name</div>
                        <input
                            key={showModal}
                            onChange={(e) => {
                                setName(e?.target?.value)
                                setError(false)
                            }} ref={inputRef} type="text" placeholder='Enter name here' />
                    </div>

                    {
                        error &&
                        <div className={styles.form_item}>
                            <div className={styles.form_item_error}>{error}</div>
                        </div>
                    }







                </div>
            </Modal.Body>
            <Button
                disabled={!name}
                className={styles.patient_consent_accept_button}
                onClick={() => { handleSubmit() }}
            >
                Save
            </Button>

        </Modal>
    )
}

export default AddDataModal